import CashFlowIframeAbstract from './cashFlowIframeAbstract';

const defaultConfig = {
    formSelector: '#takePaymentForm',
    frameContainer: 'dialogForm_cashFlowFrame',
    cashFlowParamsToFormSelector: '.credit-card-form',
    iframeLocation: 'pos',
    cssRules: [
        'input{height:17px;padding:2px;float:right;width:155px;font-size:12px;font-weight:bold;border-width:1px;}',
        'label{display:inline-block;float:left;font-size:12px;font-weight:bold;font-family:Tahoma,Arial;width:126px;text-align:right;padding-right:20px;margin-top:11px;}',
        'select{width:70px;height:21px;margin-right:10px;}',
        '.error{color:red;}'
    ],
    frameOptions: {
        useexpiry: 'true',
        usecvv: 'true',
        cardlabel: 'Card Number:',
        expirylabel: 'Expiration:',
        cvvlabel: 'CVV:',
        orientation: 'custom',
        placeholdercvv: 'Code',
        placeholdermonth: 'Month',
        placeholderyear: 'Year',
        unique: false,
        formatinput: true,
        autofocus: true,
        invalidinputevent: true,
        enhancedresponse: true
    }
};

export default class CashFlowTakePayment extends CashFlowIframeAbstract {
    constructor() {
        super(defaultConfig);
    }

    init(initConfig) {
        super.init(initConfig);
    }
}
